import { Routes, Route } from "react-router-dom";

import RealTimeTrackingListScreen from "screens/App/CRM/RealTimeTracking/RealTimeTrackingListScreen";
import RealTimeTrackingInfoScreen from "screens/App/CRM/RealTimeTracking/RealTimeTrackingInfoScreen";
import RealTimeTrackingDetailScreen from "screens/App/CRM/RealTimeTracking/RealTimeTrackingDetailScreen";
import RealTimeTrackingEditScreen from "screens/App/CRM/RealTimeTracking/RealTimeTrackingEditScreen";
import RealTimeTrackingCreateScreen from "screens/App/CRM/RealTimeTracking/RealTimeTrackingCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const RealTimeTrackingRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<RealTimeTrackingListScreen />} />
      <Route path="create" element={<RealTimeTrackingCreateScreen />} />
      <Route path=":id/detail" element={<RealTimeTrackingDetailScreen />} />
      <Route path=":id/edit" element={<RealTimeTrackingEditScreen />} />
      <Route path="info" element={<RealTimeTrackingInfoScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default RealTimeTrackingRouter;
